import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { createSegments, editSegments, getSegments, inactivateSegments } from "@services/form";
import { useIntl } from "react-intl";
import { ISegmentResponse } from "@types";
import { useT, useLocalizedName } from "@hooks";
import SettingsCrudPage from "../SettingsCrudPage";
import SettingsNameDialogs from "../SettingsNameDialogs";
import useSettingsCrudPage from "../useSettingsCrudPage";

const defaultColumnOrder = ["name"];

const SegmentsPage = () => {
  const t = useT();
  const localizedName = useLocalizedName();
  const { locale } = useIntl();

  const crud = useSettingsCrudPage({
    translationPrefix: "settings.segment",
    reloadKey: locale,
    fetchService: getSegments,
    mountOption: (data: ISegmentResponse[]) =>
      data?.map((res) => ({
        id: res.id,
        name: localizedName(res),
        date: "",
        active: res?.active,
      })),
    createService: (value) => createSegments(value),
    editService: (selected, value) => editSegments({ id: selected.id, name: value }),
    inactivateService: inactivateSegments,
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    name: t("settings.segment.column.name"),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix="settings.segment"
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <SettingsNameDialogs
        crud={crud}
        newTitle={t("settings.segment.dialog.newTitle")}
        editTitle={t("settings.segment.dialog.editTitle")}
        newPlaceholder={t("settings.segment.placeholder.name")}
        editPlaceholder={t("settings.segment.placeholder.name")}
      />
    </SettingsCrudPage>
  );
};

export default SegmentsPage;
